document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".fh-pricecalc").forEach((root) => {
    const sectionId = root.dataset.sectionId;
    const qs = (id) => root.querySelector(id);
    const qsa = (sel) => Array.from(root.querySelectorAll(sel));

    const els = {

      currencyPrefixes: qsa("[data-currency-prefix]"),

      navLinks: qsa(`#fh-nav-${sectionId} .fh-navlink`),
      sections: qsa(".fh-card"),

      qtyRequired: qs(`#fh-print-qty-${sectionId}`),
      printersAvailable: qs(`#fh-printers-${sectionId}`),

      totalPrintTime: qs(`#fh-total-print-time-${sectionId}`),
      productionTime: qs(`#fh-production-time-${sectionId}`),
      productionBadge: qs(`#fh-production-time-badge-${sectionId}`),

      hours: qs(`#fh-hours-${sectionId}`),
      minutes: qs(`#fh-minutes-${sectionId}`),
      filamentWeight: qs(`#fh-filament-weight-${sectionId}`),
      filamentType: qs(`#fh-filament-type-${sectionId}`),
      spoolPrice: qs(`#fh-spool-price-${sectionId}`),
      spoolWeight: qs(`#fh-spool-weight-${sectionId}`),

      marginCopy: qs(`#fh-margin-copy-${sectionId}`),

      printHourRate: qs(`#fh-print-hour-rate-${sectionId}`),
      printHourCost: qs(`#fh-print-hour-cost-value-${sectionId}`),
      printHourBadge: qs(`#fh-print-hour-cost-badge-${sectionId}`),
      sumPrintHour: qs(`#fh-sum-print-hour-${sectionId}`),

      labourRate: qs(`#fh-labour-rate-${sectionId}`),
      prepTime: qs(`#fh-prep-time-${sectionId}`),
      postTime: qs(`#fh-post-time-${sectionId}`),
      packTime: qs(`#fh-pack-time-${sectionId}`),


      packagingOverride: qs(`#fh-packaging-override-${sectionId}`),
      packagingButtons: qsa(".fh-option"),

      freeShipping: qs(`#fh-free-shipping-${sectionId}`),
      shippingCost: qs(`#fh-shipping-cost-${sectionId}`),

      failureRate: qs(`#fh-failure-rate-${sectionId}`),

      electricityRate: qs(`#fh-electricity-rate-${sectionId}`),
      printerPower: qs(`#fh-printer-power-${sectionId}`),

      printerCost: qs(`#fh-printer-cost-${sectionId}`),
      printerLifeHours: qs(`#fh-printer-life-hours-${sectionId}`),



      gstRate: qs(`#fh-gst-rate-${sectionId}`),
      platform: qs(`#fh-platform-${sectionId}`),
      platformPercent: qs(`#fh-platform-percent-${sectionId}`),
      platformFixed: qs(`#fh-platform-fixed-${sectionId}`),

      returnsRate: qs(`#fh-returns-rate-${sectionId}`),

      marketingEnabled: qs(`#fh-marketing-enabled-${sectionId}`),
      cpc: qs(`#fh-cpc-${sectionId}`),
      conversionRate: qs(`#fh-conversion-rate-${sectionId}`),

      addOther: qs(`#fh-add-other-${sectionId}`),
      otherList: qs(`#fh-other-list-${sectionId}`),

      costPerGram: qs(`#fh-cost-per-gram-${sectionId}`),
      energyConsumption: qs(`#fh-energy-consumption-${sectionId}`),
      printerCostHour: qs(`#fh-printer-cost-hour-${sectionId}`),

      clicksPerSale: qs(`#fh-clicks-per-sale-${sectionId}`),

      materialBadge: qs(`#fh-material-cost-badge-${sectionId}`),
      labourBadge: qs(`#fh-labour-cost-badge-${sectionId}`),
      packagingBadge: qs(`#fh-packaging-cost-badge-${sectionId}`),
      shippingBadge: qs(`#fh-shipping-cost-badge-${sectionId}`),
      failureBadge: qs(`#fh-failure-cost-badge-${sectionId}`),
      electricityBadge: qs(`#fh-electricity-cost-badge-${sectionId}`),
      depreciationBadge: qs(`#fh-depreciation-cost-badge-${sectionId}`),

      

      otherBadge: qs(`#fh-other-cost-badge-${sectionId}`),
      returnsBadge: qs(`#fh-returns-cost-badge-${sectionId}`),
      marketingBadge: qs(`#fh-marketing-cost-badge-${sectionId}`),

      sumMaterial: qs(`#fh-sum-material-${sectionId}`),
      sumLabour: qs(`#fh-sum-labour-${sectionId}`),
      sumPackaging: qs(`#fh-sum-packaging-${sectionId}`),
      sumShipping: qs(`#fh-sum-shipping-${sectionId}`),
      sumElectricity: qs(`#fh-sum-electricity-${sectionId}`),
      sumDepreciation: qs(`#fh-sum-depreciation-${sectionId}`),

      sumOther: qs(`#fh-sum-other-${sectionId}`),
      sumFailure: qs(`#fh-sum-failure-${sectionId}`),
      sumReturns: qs(`#fh-sum-returns-${sectionId}`),
      sumMarketing: qs(`#fh-sum-marketing-${sectionId}`),
      sumPlatformFixed: qs(`#fh-sum-platform-fixed-${sectionId}`),

      subtotal: qs(`#fh-subtotal-${sectionId}`),
      recommended: qs(`#fh-recommended-price-${sectionId}`),
      sumPlatformVariable: qs(`#fh-sum-platform-variable-${sectionId}`),
      sumGST: qs(`#fh-sum-gst-${sectionId}`),
      sumCustomerShipping: qs(`#fh-sum-customer-shipping-${sectionId}`),
      customerPays: qs(`#fh-customer-pays-${sectionId}`)
    };

    let selectedBoxCost = 0.45;

    function num(el, fallback = 0) {
      const value = Number(el?.value);
      return Number.isFinite(value) ? value : fallback;
    }

    function currency() {
      return els.currencySelect?.value || root.dataset.currencySymbol || "$";
    }

    function money(value) {
      return `${currency()}${Number(value || 0).toFixed(2)}`;
    }

    function setText(el, value) {
      if (el) el.textContent = value;
    }

    function hoursTotal() {
      return Math.max(0, num(els.hours)) + (Math.max(0, num(els.minutes)) / 60);
    }

    function otherCostsTotal() {
      return qsa(".fh-other-cost-input").reduce((sum, input) => sum + Math.max(0, Number(input.value || 0)), 0);
    }

    function syncCurrency() {
      const symbol = currency();
      els.currencyPrefixes.forEach((el) => { el.textContent = symbol; });
      calculate();
    }


    function applyPlatformPreset() {
      const value = els.platform?.value || "none";
      const presets = {
        none: { percent: 0, fixed: 0 },
        shopify: { percent: 1.75, fixed: 0.30 },
        etsy: { percent: 10.0, fixed: 0.45 },
        ebay: { percent: 12.0, fixed: 0.30 },
        custom: null
      };

      if (value !== "custom" && presets[value]) {
        els.platformPercent.value = presets[value].percent;
        els.platformFixed.value = presets[value].fixed.toFixed(2);
      }
      calculate();
    }

    function applyFilamentPreset() {
      const value = (els.filamentType?.value || "").toUpperCase();

      const presets = {
        PLA: 18.99,
        PETG: 16.99,
        ABS: 16.99,
        ASA: 24.99,
        TPU: 28.99,
        PC: 29.99,
        PA: 29.99
      };

      if (presets[value] != null && els.spoolPrice) {
        els.spoolPrice.value = presets[value].toFixed(2);
      }

      calculate();
    }

    function formatHours(hours) {
        const h = Math.floor(hours);
        const m = Math.round((hours - h) * 60);
        return `${h}h ${m}m`;
      }

    function calculate() {
      const printHours = hoursTotal();

      const qtyRequired = Math.max(1, num(els.qtyRequired, 1));
      const printersAvailable = Math.max(1, num(els.printersAvailable, 1));

      const totalPrintTime = printHours * qtyRequired;
      const productionTime = totalPrintTime / printersAvailable;

      const filamentWeight = Math.max(0, num(els.filamentWeight));
      const spoolPrice = Math.max(0, num(els.spoolPrice));
      const spoolWeight = Math.max(1, num(els.spoolWeight));
      const costPerGram = spoolPrice / spoolWeight;
      const materialCost = costPerGram * filamentWeight;

      const printHourCost = printHours * Math.max(0, num(els.printHourRate));
      const labourMinutes =
        Math.max(0, num(els.prepTime)) +
        Math.max(0, num(els.postTime)) +
        Math.max(0, num(els.packTime));

      const labourCost = (labourMinutes / 60) * Math.max(0, num(els.labourRate));

      const packagingCost = Math.max(0, num(els.packagingOverride, selectedBoxCost));

      const shippingCost = Math.max(0, num(els.shippingCost));
      const includeShippingInPrice = !!els.freeShipping?.checked;
      const includedShipping = includeShippingInPrice ? shippingCost : 0;
      const customerShipping = includeShippingInPrice ? 0 : shippingCost;

      const electricityRate = Math.max(0, num(els.electricityRate));
      const printerPower = Math.max(0, num(els.printerPower));
      const energyConsumption = (printerPower / 1000) * printHours;
      const electricityCost = energyConsumption * electricityRate;

      const printerCost = Math.max(0, num(els.printerCost));
      const printerLifeHours = Math.max(1, num(els.printerLifeHours, 10000));
      const printerCostPerHour = printerCost / printerLifeHours;
      const depreciationCost = printerCostPerHour * printHours;




      const otherCost = otherCostsTotal();

      const coreCost =
        materialCost +
        printHourCost +
        labourCost +
        packagingCost +
        includedShipping +
        electricityCost +
        depreciationCost +
        otherCost;

      const failureRate = Math.max(0, num(els.failureRate)) / 100;
      const failureCost = coreCost * failureRate;

      const returnsRate = Math.max(0, num(els.returnsRate)) / 100;
      const returnsCost = coreCost * returnsRate;

      const marketingCost = els.marketingEnabled?.checked
        ? (() => {
            const cpc = Math.max(0, num(els.cpc));
            const conversion = Math.max(0.1, num(els.conversionRate));
            return cpc / (conversion / 100);
          })()
        : 0;

      const clicksPerSale = els.marketingEnabled?.checked
        ? Math.ceil(100 / Math.max(0.1, num(els.conversionRate)))
        : 0;

      const platformFixed = Math.max(0, num(els.platformFixed));
      const platformRate = Math.max(0, num(els.platformPercent)) / 100;

      const costPerPart =
        coreCost +
        failureCost +
        returnsCost +
        marketingCost +
        platformFixed;

      const qty = Math.max(1, num(els.qtyRequired, 1));

      const subtotal = costPerPart * qty;

        const activeMargin = Math.max(0, num(els.marginCopy));
        const marginPct = activeMargin / 100;

        if (els.marginCopy && document.activeElement !== els.marginCopy) {
          els.marginCopy.value = Math.round(activeMargin);
        }

        if (els.markupDisplay) {
          setText(els.markupDisplay, `${Math.round(activeMargin)}%`);
        }

      const targetNet = subtotal * (1 + marginPct);
      const recommendedRetail = targetNet / Math.max(0.01, (1 - platformRate));
      const platformVariableCost = recommendedRetail * platformRate;

      const gstRate = Math.max(0, num(els.gstRate)) / 100;
      const taxableSaleAmount = recommendedRetail + customerShipping;
      const gstAmount = taxableSaleAmount * gstRate;

      const customerPays = taxableSaleAmount + gstAmount;
      setText(els.totalPrintTime, formatHours(totalPrintTime));
      setText(els.productionTime, formatHours(productionTime));
      setText(els.productionBadge, formatHours(productionTime));

      setText(els.costPerGram, money(costPerGram));
      setText(els.energyConsumption, `${energyConsumption.toFixed(3)} kWh`);
      setText(els.printerCostHour, `${money(printerCostPerHour)}/hr`);

      setText(els.clicksPerSale, clicksPerSale ? `~${clicksPerSale} clicks` : "0");

      setText(els.materialBadge, money(materialCost));
      setText(els.labourBadge, money(labourCost));
      setText(els.packagingBadge, money(packagingCost));
      setText(els.shippingBadge, money(includedShipping));
      setText(els.failureBadge, money(failureCost));
      setText(els.electricityBadge, money(electricityCost));
      setText(els.depreciationBadge, money(depreciationCost));

      setText(els.printHourCost, money(printHourCost));
      setText(els.printHourBadge, money(printHourCost));
      setText(els.sumPrintHour, money(printHourCost));


      setText(els.otherBadge, money(otherCost));
      setText(els.returnsBadge, money(returnsCost));
      setText(els.marketingBadge, money(marketingCost));

      setText(els.sumMaterial, money(materialCost));
      setText(els.sumLabour, money(labourCost));
      setText(els.sumPackaging, money(packagingCost));
      setText(els.sumShipping, money(includedShipping));
      setText(els.sumElectricity, money(electricityCost));
      setText(els.sumDepreciation, money(depreciationCost));


      setText(els.sumOther, money(otherCost));
      setText(els.sumFailure, money(failureCost));
      setText(els.sumReturns, money(returnsCost));
      setText(els.sumMarketing, money(marketingCost));
      setText(els.sumPlatformFixed, money(platformFixed));

      setText(els.subtotal, money(subtotal));
      setText(els.recommended, money(recommendedRetail));
      setText(els.sumPlatformVariable, money(platformVariableCost));
      setText(els.sumGST, money(gstAmount));
      setText(els.sumCustomerShipping, money(customerShipping));
      setText(els.customerPays, money(customerPays));
    }

    function addOtherRow() {
      if (!els.otherList) return;
      const row = document.createElement("div");
      row.className = "fh-other-row";
      row.innerHTML = `
        <input class="fh-input fh-other-row__name" type="text" placeholder="Other cost name">
        <div class="fh-inputgroup fh-other-row__value">
          <span class="fh-inputgroup__prefix" data-currency-prefix>${currency()}</span>
          <input class="fh-input fh-other-cost-input" type="number" min="0" step="0.01" value="0.00">
        </div>
      `;
      els.otherList.appendChild(row);
      row.querySelectorAll("input").forEach((input) => {
        input.addEventListener("input", calculate);
        input.addEventListener("change", calculate);
      });
    }

    function bindOptionButtons() {
      els.packagingButtons.forEach((btn) => {
        btn.addEventListener("click", () => {
          els.packagingButtons.forEach((b) => b.classList.remove("is-selected"));
          btn.classList.add("is-selected");
          selectedBoxCost = Number(btn.dataset.boxCost || 0);
          if (els.packagingOverride) {
            els.packagingOverride.value = selectedBoxCost.toFixed(2);
          }
          calculate();
        });
      });
    }

    function setupNavHighlight() {
      if (!("IntersectionObserver" in window)) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const id = entry.target.getAttribute("id");
          els.navLinks.forEach((link) => {
            link.classList.toggle("is-active", link.getAttribute("href") === `#${id}`);
          });
        });
      }, {
        rootMargin: "-20% 0px -65% 0px",
        threshold: 0.1
      });

      els.sections.forEach((section) => observer.observe(section));
    }

    [
      els.hours,
      els.minutes,
      els.filamentWeight,
      els.filamentType,
      els.qtyRequired,
      els.printersAvailable,
      els.spoolPrice,
      els.spoolWeight,
      els.marginCopy,
      els.printHourRate,
      els.labourRate,
      els.prepTime,
      els.postTime,
      els.packTime,
      els.packagingOverride,
      els.freeShipping,
      els.shippingCost,
      els.failureRate,
      els.electricityRate,
      els.printerPower,
      els.printerCost,
      els.printerLifeHours,
      els.gstRate,
      els.platform,
      els.platformPercent,
      els.platformFixed,
      els.returnsRate,
      els.marketingEnabled,
      els.cpc,
      els.conversionRate
    ].forEach((el) => {
      el?.addEventListener("input", calculate);
      el?.addEventListener("change", calculate);
    });

    els.platform?.addEventListener("change", applyPlatformPreset);
    els.filamentType?.addEventListener("change", applyFilamentPreset);
    els.addOther?.addEventListener("click", addOtherRow);

    bindOptionButtons();
    setupNavHighlight();
    applyPlatformPreset();

    syncCurrency();
    calculate();
  });
});